import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { toast } from "react-toastify";
import LgIcon from "./icons/lg.svg";
import DaIcon from "./icons/da.svg";
import useCurrentProject from "@hooks/useCurrentProject";

import KidsDistributionScreen from "./kids";
import StudentsDistribution from "./students";

import stores from "@stores";
import { getLocalisedErrorMessage } from "@helpers/errorMapper";
import studentsApi from "../../api/students.api";
import kidsApi from "../../api/kids.api";

const EinteilungScreen = () => {
  const {
    projectsStore,
  } = stores;
  const [distributionMap, setDistributionMap] = useState();
  const [errorsArr, setErrorsArr] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isManualMode, setManualMode] = useState(false);

  const { currentProject } = useCurrentProject();

  const setDistributionMode = (classes) => {
    const students = [];

    classes.forEach((classItem) => {
      if (classItem.students) {
        students.push(...classItem.students);
      } else {
        students.push(...classItem.kids);
      }
    });

    const areAllDirectAssigned = students.every(
      (student) => student.teacherName.length > 1
    );

    setManualMode(areAllDirectAssigned);
  };

  const enableManualMode = async () => {
    for (const classItem of distributionMap) {
      const classTeacher = classItem.teacherName;

      const students = classItem.students ? classItem.students : classItem.kids;

      await Promise.all(
        students.map(async (student) => {
          if (classItem.students) {
            await studentsApi.edit({
              id: student._id,
              teacherName: classTeacher,
            });
          }

          if (classItem.kids) {
            await kidsApi.edit({ id: student._id, teacherName: classTeacher });
          }
        })
      );
    }

    setManualMode(true);

    await fetchDistributionMap();
  };

  const fetchDistributionMap = async () => {
    if (!currentProject?._id) return;

    const { _id } = currentProject;
    const { type } = currentProject;

    setIsLoading(true);
    try {
      const { results, errors } = await projectsStore.fetchDistribution(
        _id,
        type
      );

      setDistributionMap(results);

      if (!errors.length) {
       setDistributionMode(results);
      }
  
      errors.length && setErrorsArr(errors);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      return false;
    }
  };

  const getBooleanLabel = (obj, key) => {
    if (obj && obj[key]) {
      return "yes";
    } else if (obj && !obj[key]) {
      return "no";
    }
  };

  const generateKidIcon = (obj, classItem) => {
    let daIcon, lgIcon;

    if (obj.teacherName === classItem.teacherName) {
      daIcon = DaIcon;
    }

    if (
      obj.germanLanguageLevel === "none" ||
      obj.germanLanguageLevel === "little"
    ) {
      lgIcon = LgIcon;
    }

    return { daIcon, lgIcon };
  };

  const generateStudentIcon = (obj, classItem) => {
    let daIcon;

    if (obj.teacherName === classItem.teacherName) {
      daIcon = DaIcon;
    }

    return { daIcon };
  }

  useEffect(() => {
    if (errorsArr.length) {
      toast.error(getLocalisedErrorMessage(errorsArr[0]))
    }
  }, [errorsArr]);

  return (
    <>
      {currentProject.type === "Nursery" && (
        <KidsDistributionScreen
          isManualMode={isManualMode}
          enableManualMode={enableManualMode}
          distributionMap={distributionMap}
          fetchDistribution={fetchDistributionMap}
          getBooleanLabel={getBooleanLabel}
          generateIcon={generateKidIcon}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}

      {currentProject.type === "School" && (
        <StudentsDistribution
          isManualMode={isManualMode}
          enableManualMode={enableManualMode}
          distributionMap={distributionMap}
          fetchDistribution={fetchDistributionMap}
          getBooleanLabel={getBooleanLabel}
          generateIcon={generateStudentIcon}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}
    </>
  );
};

export default observer(EinteilungScreen);
